import React, {useEffect, useMemo} from "react";
import {shallowEqual, useDispatch, useSelector} from "react-redux";

import {SamplesFilter} from "../../modules/SamplesFilter";
import {SamplesTable} from "../../modules/SamplesTable";
import {columns} from "../../modules/SamplesTable/ui.helpers";
import {useSamplesUIContext} from "../../../contexts/SamplesUIContext";
import {fetchSamples} from "../../../../redux/modules/samples/actions";

export function SamplesContainer() {
  const context = useSamplesUIContext();
  const dispatch = useDispatch();

  const {queryParams} = useMemo(() => ({
    queryParams: context.queryParams,
  }), [context]);

  const {sampleStore} = useSelector(state => ({
    sampleStore: state.samples,
  }), shallowEqual);

  const {totalCount, sampleList, listLoading} = sampleStore;

  useEffect(() => {
    dispatch(fetchSamples(queryParams));
  }, [queryParams, dispatch]);

  return (
    <div className="flex-grow-1">

      {/* Start:: SampleFilter */}
      <div className="mb-10">
        <SamplesFilter />
      </div>
      {/* End:: SampleFilter */}

      {/* Start:: ProductsFilter */}
      <SamplesTable
        columns={columns}
        totalCount={totalCount}
        sampleList={sampleList}
        listLoading={listLoading}
      />
      {/* End:: ProductsFilter */}
    </div>
  );
}
